export default {"src":"/_next/static/media/prevBtn.833cbbdb.svg","height":39,"width":39};